import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Overview")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "System Status", -1)
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "row mb-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "POS Name", -1)
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_13 = { class: "row mb-7" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Short-Key", -1)
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_17 = { class: "row mb-7" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Email", -1)
const _hoisted_19 = { class: "col-lg-8" }
const _hoisted_20 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Website", -1)
const _hoisted_23 = { class: "col-lg-8" }
const _hoisted_24 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Telephone", -1)
const _hoisted_27 = { class: "col-lg-8" }
const _hoisted_28 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Telephone 2", -1)
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Fax", -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Overall Notes", -1)
const _hoisted_39 = { class: "col-lg-8" }
const _hoisted_40 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_41 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Back to List")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: {
          name: 'store-information',
          params: {
            id: _ctx.$route.params.id,
          },
        },
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_switch, {
            modelValue: _ctx.formData.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
            "active-value": 10,
            "inactive-value": 25,
            placeholder: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formData.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formData.short_key), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formData.email), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formData.website), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formData.telephone), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formData.telephone2), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formData.fax), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.formData.overall_notes), 1)
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_router_link, {
        to: { name: 'online-store' },
        class: "btn btn-secondary align-self-center me-2"
      }, {
        default: _withCtx(() => [
          _hoisted_42
        ]),
        _: 1
      })
    ])
  ]))
}